const STORAGE_KEY = "DUNGEON_DRINKER";

export { STORAGE_KEY };
